import React from "react";
import Layout from "../../Components/Layout/layout";
import classes from "./denied.module.css";
function denied() {
    return (
        <Layout>
            <div className={classes["wrapper"]}>
                <code>Access Denied</code>
                <h3>You don't have permission to view this page.</h3>
                <h3>🚫🚫🚫🚫</h3>
                <h6>
                    <strong>Error Code</strong>: 403 forbidden
                </h6>
            </div>
        </Layout>
    );
}

export default denied;
